import styled from "styled-components";

import { DescriptionText } from "..";

export const ListItemText = styled(DescriptionText)`
  margin: 16px 0 16px;
`;
